import { render, staticRenderFns } from "./ExchangeModal.vue?vue&type=template&id=c611c4f0&scoped=true"
import script from "./ExchangeModal.vue?vue&type=script&lang=js"
export * from "./ExchangeModal.vue?vue&type=script&lang=js"
import style0 from "./ExchangeModal.vue?vue&type=style&index=0&id=c611c4f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c611c4f0",
  null
  
)

export default component.exports